import { ResultStream } from '@causality/core';
import { Campaign } from '@formunauts/shared/campaigning/domain';
import { CommonError } from '@formunauts/shared/errors/domain';
import * as Data from 'effect/Data';

export class CampaignFormMetadataNotFoundError extends Data.TaggedError(
  'CampaignFormMetadataNotFoundError',
)<{
  form_id: number;
  form_type: Campaign.FormType;
}> {}

export class SCOFormMetadataNotFoundError extends Data.TaggedError(
  'SCOFormMetadataNotFoundError',
)<{
  hash: string;
}> {}

export type GetCampaignFormsMetadataError =
  | ResultStream.ClientOfflineError
  | ResultStream.ClientTimeoutError
  | CommonError.GetEntityError<CampaignFormMetadataNotFoundError>;

export type GetSCOFormsMetadataError =
  | ResultStream.ClientOfflineError
  | ResultStream.ClientTimeoutError
  | CommonError.GetEntityError<SCOFormMetadataNotFoundError>;
